import { merge } from 'ramda';
import { SUCCESS, REQUEST, FAIL } from 'src/store/actions/workTimesInPeriodByJobsActions';

const initialState = {
  data: {},
  fetching: false,
  errors: [],
  splitBy: ['']
};

const workTimesInPeriodByJobs = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return merge(state, { fetching: true });
    case SUCCESS:
      return merge(state, {
        data: action.workTimesInPeriodByJobs, fetching: false, errors: [], splitBy: action.splitBy
      });
    case FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    default:
      return state;
  }
};

export default workTimesInPeriodByJobs;
